import { Glyphicon } from 'react-bootstrap';
import styled from 'styled-components';

export const ActionsCellContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;

  padding: 8px;
  color: #3a84d8;
`;

export const SyncNowIcon = styled(Glyphicon).attrs({
  glyph: 'repeat',
})`
  cursor: pointer;
`;

export const RemoveIcon = styled(Glyphicon).attrs({
  glyph: 'trash',
})`
  cursor: pointer;
`;
